"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_1 = __importStar(require("@seaweb/coral/hoc/styled"));
var warning_1 = __importDefault(require("warning"));
var useWrapEvent_1 = __importDefault(require("@seaweb/coral/hooks/useWrapEvent"));
var number_1 = require("@seaweb/coral/utils/number");
var useForkRef_1 = __importDefault(require("@seaweb/coral/hooks/useForkRef"));
var fallback_1 = __importDefault(require("@seaweb/coral/utils/fallback"));
var useRovingIndex_1 = __importDefault(require("@seaweb/coral/hooks/useRovingIndex"));
var childrenWithIndex_1 = __importDefault(require("@seaweb/coral/utils/childrenWithIndex"));
var TabsContext_1 = require("./TabsContext");
var TabUnderline_1 = __importDefault(require("./TabUnderline"));
var TabListContent = styled_1.default.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  display: flex;\n  position: relative;\n\n  ", "\n\n  ", "\n"], ["\n  display: flex;\n  position: relative;\n\n  ",
    "\n\n  ",
    "\n"])), function (_a) {
    var _orientation = _a._orientation;
    switch (_orientation) {
        case TabsContext_1.TabsOrientations.Vertical:
            return styled_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n          flex-direction: column;\n          align-items: stretch;\n          min-width: 120px;\n        "], ["\n          flex-direction: column;\n          align-items: stretch;\n          min-width: 120px;\n        "])));
        case TabsContext_1.TabsOrientations.Horizontal:
            return styled_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n          align-items: center;\n        "], ["\n          align-items: center;\n        "])));
        default:
            return null;
    }
}, function (_a) {
    var _orientation = _a._orientation, variant = _a.variant, colors = _a.theme.colors;
    switch (variant) {
        case TabsContext_1.TabVariants.Text:
        case TabsContext_1.TabVariants.Card:
            return styled_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject([""], [""])));
        case TabsContext_1.TabVariants.Bar:
            return _orientation === TabsContext_1.TabsOrientations.Vertical
                ? styled_1.css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n              box-shadow: -1px 0 0 ", " inset;\n            "], ["\n              box-shadow: -1px 0 0 ", " inset;\n            "])), colors.border) : styled_1.css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n              box-shadow: 0 -1px 0 ", " inset;\n            "], ["\n              box-shadow: 0 -1px 0 ", " inset;\n            "])), colors.border);
        default:
            return null;
    }
});
var TabList = react_1.forwardRef(function (_a, ref) {
    var as = _a.as, _b = _a.role, role = _b === void 0 ? 'tablist' : _b, children = _a.children, onKeyDown = _a.onKeyDown, _c = _a.variant, variant = _c === void 0 ? TabsContext_1.TabVariants.Bar : _c, underlineProp = _a.underline, itemHeightProp = _a.itemHeight, props = __rest(_a, ["as", "role", "children", "onKeyDown", "variant", "underline", "itemHeight"]);
    warning_1.default(Object.values(TabsContext_1.TabVariants).includes(variant), "TabList: Unknown variant: '" + variant + "'.");
    var _d = TabsContext_1.useTabsContext(), id = _d.id, activeIndex = _d.activeIndex, setActiveIndex = _d.setActiveIndex, setCycle = _d.setCycle, orientation = _d.orientation;
    var ariaAttrs = {
        'aria-orientation': orientation,
    };
    var _e = useRovingIndex_1.default(), tabsRef = _e.itemsRef, getIndexes = _e.getIndexes, setItemRef = _e.setItemRef, getRelativeTarget = _e.getRelativeTarget;
    var move = function (distance) {
        var totalLength = react_1.Children.count(children);
        var indices = getIndexes();
        var _a = __read(getRelativeTarget(activeIndex, distance, { overflow: 'none' }), 3), targetIndexIndex = _a[2];
        if (targetIndexIndex > indices.length - 1) {
            setCycle(function (cycle) { return cycle + totalLength; });
        }
        else if (targetIndexIndex < 0) {
            setCycle(function (cycle) { return cycle - totalLength; });
        }
        var nextIndex = indices[number_1.mod(targetIndexIndex, indices.length)];
        setActiveIndex(nextIndex);
        tabsRef.current[nextIndex].focus();
    };
    var handleNavigate = useWrapEvent_1.default(onKeyDown, function (e) {
        switch (orientation) {
            case TabsContext_1.TabsOrientations.Horizontal: {
                if (e.key === 'ArrowRight')
                    move(1);
                if (e.key === 'ArrowLeft')
                    move(-1);
                break;
            }
            case TabsContext_1.TabsOrientations.Vertical: {
                if (e.key === 'ArrowDown') {
                    move(1);
                    e.preventDefault();
                }
                if (e.key === 'ArrowUp') {
                    move(-1);
                    e.preventDefault();
                }
                break;
            }
            default:
        }
    });
    var ownRef = react_1.useRef(null);
    var handleRef = useForkRef_1.default(ref, ownRef);
    var underline = fallback_1.default(underlineProp, react_1.useMemo(function () {
        switch (variant) {
            case TabsContext_1.TabVariants.Bar:
                return react_1.default.createElement(TabUnderline_1.default, null);
            case TabsContext_1.TabVariants.Text:
            case TabsContext_1.TabVariants.Card:
            default:
                return null;
        }
    }, [variant]));
    var itemHeight = fallback_1.default(itemHeightProp, react_1.useMemo(function () {
        switch (variant) {
            case TabsContext_1.TabVariants.Text:
                return 24;
            case TabsContext_1.TabVariants.Card:
                return 40;
            case TabsContext_1.TabVariants.Bar:
            default:
                return 36;
        }
    }, [variant]));
    var ctx = {
        tabsRef: tabsRef,
        setItemRef: setItemRef,
        tabListRef: ownRef,
        variant: variant,
        itemHeight: itemHeight,
    };
    return (react_1.default.createElement(TabsContext_1.TabListContext.Provider, { value: ctx },
        react_1.default.createElement(TabListContent, __assign({ as: as, role: role, id: "tabs:" + id + "-tab-list", ref: handleRef, onKeyDown: handleNavigate, _orientation: orientation, variant: variant }, ariaAttrs, props),
            childrenWithIndex_1.default(children),
            underline)));
});
exports.default = react_1.memo(TabList);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
